export const VIRTUALIZED_HEADER_ROW = { headerRow: true }
export const DEFAULT_ROW_HEIGHT = 48
export const defaultGetDerivedRows = ({ rows }) => rows

export const defaultRowColumnKey = 'default'
export const defaultGetRowColumnsKey = () => defaultRowColumnKey

const inBetween = (min, max, val) => {
    if (min && val < min) {
        return min
    }
    if (max && val > max) {
        return max
    }
    return val
}

/**
 *
 * Calculates a width of every column based on `width`, `minWidth`, `maxWidth`, `grow` properties of a column and `width` of their container.
 *
 * We use 'shrink-first approach', which means horizontal scrollbar will apper as late as possible.
 * It's achieved by shrinking all columns that are allowed to shrink based on their `minWidth` values.
 * @param {*} { width, scrollbarWidth, columns }
 * @returns An object of pairs of column indexes as keys and values as width
 */
// todo: #optimize :)
export const calculateColumnIndexToWidth = ({ width, scrollbarWidth, columns }) => {
    const nonResizableIndexToWidth = {}
    columns.forEach((col, index) => {
        if (col.width) {
            nonResizableIndexToWidth[index] = col.width
        }
    })

    const occupiedWidth = columns.reduce((acc, col) => acc + (col.width || 0), 0)
    const columnKeyToWidthTemp = {}
    let freeWidth = width - occupiedWidth - scrollbarWidth
    let availableToResize = [...columns.filter(col => !col.width)]
    let availableToGrow = []
    let availableToShrink = []

    while (freeWidth) {
        // ? We use toFixed because freeWidth can get quite small
        // ? it can cause js to treat these expressions in an incorrect way: very small freeWidth + 100 = 100
        // ? when that happens, it completely breaks logic of space distibution
        freeWidth = +freeWidth.toFixed(10)
        const currentResizable =
            freeWidth > 0 ? [...availableToGrow, ...availableToResize] : [...availableToShrink, ...availableToResize]
        if (!currentResizable.length) {
            break
        }

        const growsCount = currentResizable.reduce((acc, col) => acc + col.grow, 0)
        const oneGrow = freeWidth / growsCount
        availableToResize = []
        availableToGrow = []
        availableToShrink = []

        currentResizable.forEach(col => {
            const prevWidth = columnKeyToWidthTemp[col.key] || 0
            const suggestedWidth = col.grow * oneGrow + prevWidth
            const widthToUse = inBetween(col.minWidth, col.maxWidth, suggestedWidth)
            if (suggestedWidth > widthToUse) {
                availableToShrink.push(col)
            } else if (suggestedWidth < widthToUse) {
                availableToGrow.push(col)
            } else {
                availableToResize.push(col)
            }
            columnKeyToWidthTemp[col.key] = widthToUse
            freeWidth = freeWidth - widthToUse + prevWidth
        })
    }

    const columnKeyToIndexMap = new Map(columns.map((col, index) => [String(col.key), index]))
    const resizableIndexToWidth = Object.keys(columnKeyToWidthTemp).reduce(
        (acc, key) => ({
            ...acc,
            [columnKeyToIndexMap.get(key)]: columnKeyToWidthTemp[key]
        }),
        {}
    )
    const columnIndexToWidth = {
        ...nonResizableIndexToWidth,
        ...resizableIndexToWidth
    }

    return columnIndexToWidth
}

/**
 * Creates styles to show cursor on hover for specific table rows which start with the `rowStartKey` key.
 *
 * @param {String} rowStartKey
 */
export const makeVirtualizedRowClickable = rowStartKey => ({
    [`&[rowkey^="${rowStartKey}"]:hover [clickablearea="true"]`]: {
        cursor: 'pointer'
    }
})
